import { convertUnitTimeline } from './convertUnitTimeline'

export function convertSummary(data) {
    let players = data.players.map(player => {

        let unitData = convertUnitTimeline(player);

        let timeline = player.resources.timestamps.map((time, index) => {
            return {
                time: time,
                resources_total: player.resources.food[index],
                resources_food: player.resources.food[index],
                resources_gold: player.resources.gold[index],
                resources_wood: player.resources.wood[index],
                resources_stone: player.resources.stone[index],
                resources_oliveoil: player.resources.oliveoil ? player.resources.oliveoil[index] : null,
                score_total: player.resources.total[index],
                score_military: player.resources.military[index],
                score_economy: player.resources.economy[index],
                score_technology: player.resources.technology[index],
                score_society: player.resources.society[index],
                population_worker: unitData.timelineVillagers[index],
                //Fish + traders + vills
                population_economy: unitData.timelineEconomyUnits[index],
                //Cattle only
                population_cattle: unitData.timelineCattle[index],
                //Fish + traders + vills + cattle
                population_economy_total: unitData.timelineTotalEconomyUnits[index]
            };
        });

        return {
            name: player.name,
            civilization: player.civilization,
            apm: player.apm,
            result: player.result,
            scores: { ...player.score },
            timeline: timeline,
            totalResourcesGathered: player.totalResourcesGathered,
            maxVillagers: unitData.maxVillagers,
            maxTraders: unitData.maxTraders,
            maxFishingShips: unitData.maxFishingShips,
            maxEconomyUnits: unitData.maxEconomyUnits,
            feudalAge: player.actions.feudalAge?.[0],
            castleAge: player.actions.castleAge?.[0],
            imperialAge: player.actions.imperialAge?.[0],
            economyLost: unitData.economyLost
        }
    });

    return {
        mapName: data.mapName,
        duration: data.duration,
        mapSizeMaxPlayers: data.mapSizeMaxPlayers,
        players
    }
}